// extracted by mini-css-extract-plugin
module.exports = {"header":"contact-module--header--37m3A","sidebar":"contact-module--sidebar--2s9Gd","icons":"contact-module--icons--25VC2"};